import { fmt } from "@nabble/ui";
import type { DataRequest } from "../../../../api/dataRequests";
import { isAnswered } from "../../../../model/dataRequests";

/** The answer to a request, or when it is due (and why it was extended). */
export function AnswerCell({ request: r }: { request: DataRequest }): React.JSX.Element {
  if (isAnswered(r.status)) {
    return (
      <div className="nb-cell-stack">
        {r.resolution ? <span style={{ whiteSpace: "pre-wrap" }}>{r.resolution}</span> : null}
        {r.resolvedAt ? <span className="nb-cell-sub">{`Answered on ${fmt.date(r.resolvedAt)}`}</span> : null}
      </div>
    );
  }
  return (
    <div className="nb-cell-stack">
      <span>{`Answer by ${fmt.date(r.dueAt)}`}</span>
      {r.extended ? (
        <span className="nb-cell-sub" style={{ whiteSpace: "pre-wrap" }}>
          {r.extensionReason ? `We needed more time: ${r.extensionReason}` : "We needed more time."}
        </span>
      ) : null}
    </div>
  );
}
